import React, { useEffect, useState } from "react";
import { Create, SimpleForm, TextInput, required, useRedirect, useNotify, SelectInput, Button } from "react-admin";
import { useFormContext } from "react-hook-form";  
import { areaChoices, formatPostalCode, handleAddressChange, handleCityListLoad, handlePostCodeChange, handleTownListLoad } from "../common";
import { CircularProgress } from "@mui/material";

const RequesterCreate = () => {
  const redirect = useRedirect();
  const notify = useNotify();


  const FormComponent = () =>{
  const { setValue, getValues } = useFormContext();

  const [cityList,setCityList] = useState([]);
  const [selectPref,setSelectPref] = useState(null);
  const [selectCity,setSelectCity] = useState(null);
  const [selectTown,setSelectTown] = useState(null);
  const [townList, setTownList] = useState([]);
  const [postLoad, setPostLoad] = useState(false);
  const [addressLoad, setAddressLoad] = useState(false);


  useEffect(() => {
    setCity();
  }, [selectPref]);

  const setCity = async() =>{
    if(selectPref){
      const cityList = await handleCityListLoad(selectPref);
      setCityList(cityList);
    }
  }

  useEffect(()=>{
    setTown();
  },[selectCity]);

  const setTown = async() =>{
    if(selectCity && selectPref){
      const townList = await handleTownListLoad(selectPref,selectCity);
      setTownList(townList);
    }
  }

  useEffect(() => {
    initAddress();
  }, []);

  const initAddress = async() =>{
    setSelectCity("ひたちなか市")
    setSelectPref("茨城県");
  }

    return (
      <>
        <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <TextInput source="companyName" label="会社名"/>
        </div>
        <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <TextInput source="postCode" label="郵便番号"  style={{marginRight:"10px",flex:"1"}}/>
          <div style={{margin:"auto 0",flex:"1"}}>
            <Button onClick={() => {
              setAddressLoad(true)
              handlePostCodeChange(getValues("postCode")).then((data)=>{
                if(data){
                  const { address1, address2, address3 } = data;
                  if(address1){
                    setSelectPref(address1);
                    setValue("address",address1);
                  }
                  if(address2){
                    setSelectCity(address2);
                    setValue("address2",address2);
                  }
                  if(address3){
                    setSelectTown(address3);
                    setValue("address3",address3);
                  }
                }
              }).catch((e)=>{
                alert(`住所の取得に失敗しました:${e}`)
              }).finally(()=>{
                setAddressLoad(false);
              })
            }}
            >{addressLoad && <CircularProgress size={16} sx={{ mr: 1 }} />}郵便番号で自動入力</Button>
          </div>
        </div>
          <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <SelectInput source="address" label="都道府県" 
            style={{ marginRight: "5px", flex: 1.5 }} 
            choices={areaChoices}
            onChange={(e)=>{
              const pref = areaChoices.find((item) => item.name === e.target.value);
              if(pref){
                setSelectPref(pref.name)
              }
              else{
                setSelectPref(null)
              }
            }}
            optionValue="name" 
            value={selectPref}
            defaultValue={selectPref}
          />
          <SelectInput source="address2" label="市区町村"
            style={{ marginRight: "5px", flex: 1.5 }}
            choices={cityList}
            optionValue="name" 
            onChange={(e)=>{
              const city = cityList.find((item) => item.name === e.target.value);
              if(city){
                setSelectCity(city.name)
              }
              else{
                setSelectCity(null)
              }
            }}
            value={selectCity}
            defaultValue={selectCity}
          />
          <SelectInput source="address3" label="町域"
            style={{ marginRight: "5px", flex: 1.5 }}
            choices={townList}
            optionValue="name" 
            onChange={(e)=>{
              const town = townList.find((item) => item.name === e.target.value);
              if(town){
                setSelectTown(town.name)
              }
              else{
                setSelectTown(null)
              }
            }}
            value={selectTown}
          />
          <TextInput source="address4" label="その他住所" style={{ flex: 3 }}/>
          <div style={{margin:"auto 0", flex: 1.5,marginLeft:"10px" }}>
            <Button onClick={() => {
              setPostLoad(true)
              handleAddressChange( getValues("address")+getValues("address2")+getValues("address3")+getValues("address4")).then((postCode)=>{
                if(postCode){
                  setValue("postCode",postCode);
                }
                }).catch((e)=>{
                  alert(`郵便番号の取得に失敗しました:${e}`)
                }).finally(()=>{
                  setPostLoad(false);
                })
              }}
            >{postLoad && <CircularProgress size={16} sx={{ mr: 1 }} />}住所で自動入力</Button>
          </div>
        </div>
        <div style={{display:"flex", justifyContent:"space-between",width:"100%"}}>
          <TextInput source="phone" label="電話番号" style={{marginRight:"10px"}}/>
          <TextInput source="telephone" label="電話番号２" style={{marginRight:"10px"}} />
          <TextInput source="fax" label="FAX" />
        </div>
        <TextInput source="remarks" label="備考" multiline minRows={3} />
        </>
    )
  }

  return (
    <Create mutationMode="pessimistic"
      mutationOptions={{ 
        onSuccess: () => {
          notify('作成が完了しました', { type: 'success' }); 
          window.location.reload();
        }
      }}
    >
      <SimpleForm
        onKeyDown={e => {
          if (e.key === 'Enter') {
              e.preventDefault();
          }
        }}
      >
        <FormComponent />
      </SimpleForm>
    </Create>
  )
};

export default RequesterCreate;
